import React from 'react'
import { Text } from 'react-native'
import { InfoModal } from '../ui/InfoModal'

/** Short explainer behind the "?" next to the profile's unranked toggle. */
export function UnrankedGamesHelpModal({ visible, onClose }: { visible: boolean; onClose: () => void }) {
  return <InfoModal visible={visible} onClose={onClose} variant="help" title="Unranked games"
    closeLabel="Close unranked games help" testID="unranked-games-help">
    <Text className="font-typed text-ink text-sm">
      Unranked games are games you play against bots only, with no other human players.
    </Text>
    <Text className="font-typed text-ink-soft text-sm">
      They don&apos;t count toward your ranked record or the Hall of Fame. Any game that starts with two
      or more human players is ranked, even if a player is later replaced by a bot.
    </Text>
  </InfoModal>
}
